import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import TabPanel from "../Reusable/Tab";
import ChangePassword from "./ChangePassword";
//@ts-ignore
import { FileUpload } from "@careinfo/file-upload-service";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import UserLoginInfo from "./UserLoginInfo";
import AssignGroup from "./AssignGroup";
import BankDetails from "./BankDetails";
import LoginLimit from "./LoginLimit";
const UpdateStaff = (props: any) => {
  const { data, roles, profile, bankData } = props;
  const { data: addressData, refetch } = useGetHook({
    queryKey: ["address", `address-${data?.id}`],
    url: APIS.ADDRESS,
    params: {
      user: data?.id,
    },
  });

  return (
    <>
      <TabPanel
        tabTitle={[
          "Update User",
          // "Profile",
          "Roles",
          // "Address",
          "Change Password",
          "Bank Details",
          "Documents",
          "Login Limit",
        ]}
        tabPanels={[
          <>
            <UserLoginInfo refetch={refetch} user={data} profile={profile} />
          </>,
          // <>
          //   <UpdateUserProfile user={data} />
          // </>,
          <>
            <AssignGroup roles={roles} user={data} />
          </>,
          // <>
          //   <UpdateAddress refetch={refetch} id={addressData?.[0]?.id} />
          // </>,
          <>
            <div className={tw` max-w-md`}>
              <ChangePassword user={data} email={data?.email} />
            </div>
          </>,
          <>
            <BankDetails user={data} bankData={bankData} />
          </>,
          <>
            <FileUpload object_id={data?.id} />
          </>,
          <>
            <LoginLimit refetch={refetch} user={data} />
          </>,
        ]}
      />
    </>
  );
};

export default UpdateStaff;
